export { commitPendingChanges } from './commitPendingChanges';
export { getObjectId, setPrimaryObjectIdGenerator } from './objectIdentity';
export { merge } from './merge';
export { changeCascader } from './changeDetection';
//# sourceMappingURL=index.js.map